import type { Section } from '../../domain'
import { t } from '../strings'

/** Título de una sección en la hoja: su etiqueta, o el nombre de su tipo. «Parte» no se muestra. */
export function sectionTitle(section: Section): string {
  if (section.label) return section.label
  return section.kind === 'other' ? '' : t.sections[section.kind]
}

const JUMP_WORDS = 3
const JUMP_CHARS = 22
const JUMP_CHORDS = 3

/**
 * Texto del botón para saltar a una sección. Si la sección no tiene nombre (lo normal en lo que se
 * pega de una web), se reconoce por cómo empieza su letra, que es como la recuerda quien toca; si
 * es solo de acordes, por sus primeros acordes.
 */
export function sectionJumpLabel(section: Section, show: (symbol: string) => string): string {
  const title = sectionTitle(section)
  if (title) return title

  const lyric = section.lines.find((line) => line.kind !== 'comment' && /\p{L}/u.test(line.text))
  if (lyric) {
    const full = lyric.text.trim()
    const words = full.split(/\s+/)
    let label = words.slice(0, JUMP_WORDS).join(' ')
    if (label.length > JUMP_CHARS) label = label.slice(0, JUMP_CHARS)
    label = label.replace(/[\s,.;:¡!¿?-]+$/, '')
    return label.length < full.length ? `${label}…` : label
  }

  const chords = section.lines.flatMap((line) => line.chords.map((anchor) => show(anchor.chord)))
  if (chords.length > 0) {
    const shown = chords.slice(0, JUMP_CHORDS).join(' ')
    return chords.length > JUMP_CHORDS ? `${shown}…` : shown
  }
  return t.sections.other
}
